import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts('data', 'privacyPolicies');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'privacy_policies',
  type: 'get',
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/data/privacyPolicies.js